import { Align } from "@/consts/Align";
import { FC, ReactNode, PropsWithChildren } from "react";

interface Props {
  title: string;
  description?: ReactNode;
  align?: Align;
}

const InputLayout: FC<PropsWithChildren<Props>> = ({
  title,
  description,
  align,
  children,
}): JSX.Element => {
  return (
    <div style={{ textAlign: align }} className="space-y-24">
      <div className="space-y-16">
        <h1 className="font-bold text-center text-lg laptop:text-xl">
          {title}
        </h1>
        {description && <div className="text-sm">{description}</div>}
      </div>
      <div className="laptop:min-w-[480px]">{children}</div>
    </div>
  );
};

InputLayout.defaultProps = {
  align: Align.Center,
};

export default InputLayout;
